import React, { useState, useEffect } from 'react';
import { Row, Col, Card, CardBody } from 'reactstrap';

import { activateAuthLayout } from '../../../store/actions';
import { connect } from 'react-redux';
import { gql } from 'apollo-boost';
import { useQuery } from '@apollo/react-hooks';
import { getProposalURL, getQuoteBuilderURL } from '../../../helpers/common';
import { useHistory } from 'react-router';

const DATA = gql`
  query Data($QuoteId: ID) {
    Quote(QuoteId: $QuoteId) {
      QuoteId
      CustomerLogo
      CompanyName
      Description
      Description
      WorkflowStep
      Token
      CurrentVersionId
      Status
      SignedDate
      QuoteAccessLogs {
        AccessLogId
        IP
        GeoIPCity
        GeoIPState
        GeoIPCountry
        AccessTag
        Timestamp
      }
      QuoteVersions {
        VersionId
        Token
        File
        Timestamp
      }
    }
  }
`;

const QuoteBuilderCustomerAccepted = ({ activateAuthLayout, ...props }) => {
  useEffect(() => { activateAuthLayout(); }, [activateAuthLayout]);

  const history = useHistory();

  // initialize states
  const [proposalURL, setProposalURL] = useState('');

  // initialize apollo graphql queries and mutations
  const { data, loading } = useQuery(DATA, {
    variables: { QuoteId: props.quoteId },
  });

  useEffect(() => {
    if (data && data.Quote) {
      if (data.Quote.WorkflowStep !== 'CUSTOMER_ACCEPTED') {
        history.replace(getQuoteBuilderURL(data.Quote.WorkflowStep, data.Quote.QuoteId));
        return;
      }
      setProposalURL(getProposalURL(data.Quote, false));
    }
  }, [data, history]);

  const downloadSignedProposal = (e) => {
    e.preventDefault();
    const signedProposalURL = proposalURL.replace(
      '/proposal/',
      '/proposal-pdf/'
    );
    window.open(signedProposalURL, '_blank');
  };

  const viewSignedProposal = (e) => {
    e.preventDefault();
    window.open(`${proposalURL}?preview`, '_blank');
  };

  return (
    <React.Fragment>
      {data && data.Quote && !loading && (
        <div className="content">
          <div className="container-fluid">
            <div className="page-title-box">
              <Row className="align-items-center">
                <Col sm="6">
                  <h4 className="page-title">{data.Quote.Description} - Customer Accepted</h4>
                </Col>
              </Row>
            </div>

            <Row>
              <Col lg="12">
                <Card>
                  <CardBody className="text-center">
                    <h5>
                      The customer has accepted this proposal and has signed
                      online. <br />
                      The order has progressed to provisioning.
                    </h5>
                    {data.Quote.SignedDate !== null && (
                      <>
                        <button
                          className="btn btn-success btn-lg my-1"
                          onClick={viewSignedProposal}
                        >
                          View Service Agreement Online
                        </button>{' '}
                        <button
                          className="btn btn-dark btn-lg my-1"
                          onClick={downloadSignedProposal}
                        >
                          Download Service Agreement
                        </button>
                      </>
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default connect(null, { activateAuthLayout })(
  QuoteBuilderCustomerAccepted
);
